// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fontZawgyi_5725fe', '__fontZawgyi_Fallback_5725fe'"},"className":"__className_5725fe"};